function getFilename(path) {
    return path.substring(path.lastIndexOf("/") + 1)
  }
  
  export default getFilename